// Shared PR discount resolution for every cart/checkout preview — mirrors
// backend/server.py's _pr_discount_pct() and the PR branch of
// _apply_discount_and_shipping() exactly, so the cart drawer and the
// checkout page can never drift apart on what a PR account will actually
// be charged (each had its own hardcoded 25% copy before, which fell out
// of sync the moment per-account custom_pr_discount was introduced).

export const prDiscountPct = (user) =>
  (user?.custom_pr_discount != null) ? Number(user.custom_pr_discount) : 25;

export const isPrAccount = (user) => (user?.role_tag || "cliente") === "pr";

export const prAutoDiscountAmount = (user, subtotal) => {
  if (!isPrAccount(user)) return 0;
  return Math.round(subtotal * (prDiscountPct(user) / 100) * 100) / 100;
};

// PR accounts never stack multiple codes — only the single BEST admin-flagged
// "pr_override" code (if any) can beat the automatic discount; whichever of
// the two is worth more to the customer wins, still a single amount.
export const prBestOverride = (discounts, subtotal) =>
  (discounts || []).reduce((best, d) => {
    if (!d?.valid || !d.pr_override) return best;
    const amt = Math.min(Number(d.value_eur) || 0, subtotal);
    return amt > (best?.amount || 0) ? { code: d.code, amount: amt, free_shipping: !!d.free_shipping } : best;
  }, null);

// Italian-locale percentage label ("12,5" not "12.5"); whole numbers stay plain ("25").
export const pctLabel = (n) => {
  const num = Number(n) || 0;
  const s = Number.isInteger(num) ? String(num) : num.toFixed(1);
  return s.replace(".", ",");
};
